import React, { useState, useEffect } from "react";
import { usersApi } from "../utils/api";
import { GreenSwitch } from "./ui/green-toggle";

type EditUserModalProps = {
  defaultValues: any;
  isOpen: boolean;
  onClose: () => void;
  onEdit: (updatedUser: any) => void;
};

const EDIT_FIELDS = ["id", "name", "email", "mobile", "location", "status"];

const EditUserModal: React.FC<EditUserModalProps> = ({
  defaultValues,
  isOpen,
  onClose,
  onEdit,
}) => {
  // Ensure form initializes with correct values on open
  const [form, setForm] = useState(defaultValues || {});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setForm(defaultValues || {});
    }
  }, [isOpen, defaultValues]);

  // Always enabled
  const editEnabled = true;

  const handleChange = (e: any) => {
    const { name, value, type, checked } = e.target;
    setForm((prev: any) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleEdit = () => {
    onUserDataUpdateBtnPress();
  };

  const onUserDataUpdateBtnPress = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No authentication token found");
        return;
      }

      const payload = {
        id: form?.id,
        name: form?.name,
        email: form?.email,
        mobile: form?.mobile ?? form?.phone ?? "",
        location: form?.location,
        is_active: form?.status,
      };

      const response = await usersApi.updateUserDetails(payload);

      if (response?.statusCode === 200) {
        onEdit(payload);
        onClose();
      } else {
        console.error("Invalid API response structure for users");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;
  console.log("asdfasdfasdf", form);

  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-content">
        <h2 className="text-xl font-bold mb-5">Edit User Details</h2>
        <div className="form-group">
          <label>Name:</label>
          <input
            name="name"
            value={form?.name ?? ""}
            onChange={handleChange}
            placeholder="Name"
            className="modal-input"
          />
        </div>
        <div className="form-group">
          <label>Email:</label>
          <input
            name="email"
            value={form?.email ?? ""}
            onChange={handleChange}
            placeholder="Email"
            className="modal-input"
          />
        </div>
        <div className="form-group">
          <label>Phone:</label>
          <input
            name="mobile"
            value={form?.mobile ?? form?.phone ?? ""}
            onChange={handleChange}
            placeholder="Phone"
            className="modal-input"
          />
        </div>
        <div className="form-group">
          <label>Location:</label>
          <input
            name="location"
            value={form?.location ?? ""}
            onChange={handleChange}
            placeholder="Location"
            className="modal-input"
          />
        </div>
        <div className="form-group">
          <label>Active:</label>
          <GreenSwitch
            checked={form?.status ?? false}
            onChange={(e: any) =>
              setForm((prev: any) => ({
                ...prev,
                is_active: !form?.status,
              }))
            }
            aria-label="Toggle active status"
            disabled={false}
          />
        </div>
        <div className="modal-actions">
          <button onClick={handleEdit} disabled={loading} className="modal-btn">
            {loading ? "Loading..." : "Edit"}
          </button>
          <button onClick={onClose} className="modal-btn cancel">
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default EditUserModal;
